/**
 * FormBuilderToolbar — top header bar for the AdvancedFormBuilder
 * Extracted from AdvancedFormBuilder.js (Phase 3 split)
 */
import React from 'react';
import { useFormBuilder } from './FormBuilderContext';

export function FormBuilderToolbar() {
  const {
    sections, globalElements, isFullscreen,
    hasExistingForm, toggleFullscreen, generateForm,
  } = useFormBuilder();

  return (
    <div className="builder-header">
      <div className="builder-header-content">
        <h2>Advanced Form Builder</h2>
        {hasExistingForm() && (
          <div className="form-stats">
            <span className="stat">
              {sections.length} Section{sections.length > 1 ? 's' : ''}
            </span>
            <span className="stat">
              {sections.reduce((total, s) => total + s.elements.length, 0) + globalElements.length} Elements
            </span>
            {globalElements.length > 0 && (
              <span className="stat global-elements">
                {globalElements.length} Global Element{globalElements.length > 1 ? 's' : ''}
              </span>
            )}
          </div>
        )}
      </div>
      <div className="header-actions">
        <button
          className="fullscreen-btn"
          onClick={toggleFullscreen}
          title={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
        >
          {isFullscreen ? '⤢' : '⤡'}
        </button>
        <button className="generate-btn" onClick={generateForm}>
          {hasExistingForm() ? 'Update Form' : 'Generate Form'}
        </button>
      </div>
    </div>
  );
}
